import { atom } from 'nanostores';

export interface SelectedElementPayload {
  file: string;
  line: number;
  tag: string;
  classes: string;
  textSnippet: string;
  computedStyles: Record<string, string>;
  /* Optional — sent by newer selector scripts; absent on pods still running an
   * older template, so every consumer must tolerate undefined. */
  /** Full (bounded) innerText, the "before" side of a direct text edit. */
  text?: string;
  /** Raw src attribute for <img> elements — the search key for a direct swap. */
  src?: string;
  /** True when the element holds only text, so in-place editing can't destroy markup. */
  editableText?: boolean;
}

/** css-prop (kebab-case) → new value + original value */
export type StyleDeltas = Record<string, { value: string; was: string }>;

export const $selectorAvailable = atom<boolean>(false);
export const $selectMode = atom<boolean>(false);
export const $selectedElement = atom<SelectedElementPayload | null>(null);
export const $styleDeltas = atom<StyleDeltas>({});
export const $styleSaveRequest = atom<{ selection: SelectedElementPayload; deltas: StyleDeltas } | null>(null);

/**
 * Fallback channel for direct edits (text/image/style) that couldn't be applied
 * deterministically: holds a ready-to-send chat prompt. Consumed by
 * Chat.client the same way as `$integrationRequest` — nulled before dispatch.
 */
export const $elementEditFallback = atom<string | null>(null);

export function setSelectedElement(p: SelectedElementPayload | null) {
  $selectedElement.set(p);
  $styleDeltas.set({});
}

export function clearSelection() {
  $selectedElement.set(null);
  $styleDeltas.set({});
  $styleSaveRequest.set(null);
  $selectMode.set(false);
}
